import {
	Cross2Icon,
	ExclamationTriangleIcon,
	InfoCircledIcon,
} from "@radix-ui/react-icons"

import styles from "./ErrorNotification.module.scss"

import type { NotificationItem } from "./types"

export function SingleBanner({
	notification,
	onDismiss,
	onBannerClick,
}: {
	notification: NotificationItem
	onDismiss: (id: string) => void
	onBannerClick: () => void
}) {
	const isInfo = notification.kind === "info"

	return (
		<div className={styles.container}>
			<div
				className={`${styles.singleBanner} ${isInfo ? styles.singleBannerInfo : ""}`}
				onClick={onBannerClick}
				role={isInfo ? "status" : "alert"}
				aria-live={isInfo ? "polite" : "assertive"}
				aria-atomic="true"
			>
				<div className={`${styles.icon} ${isInfo ? styles.iconInfo : ""}`}>
					{isInfo ? (
						<InfoCircledIcon width={18} height={18} />
					) : (
						<ExclamationTriangleIcon width={18} height={18} />
					)}
				</div>
				<div className={styles.message}>{notification.message}</div>
				<button
					className={styles.closeButton}
					onClick={(e) => {
						e.stopPropagation()
						onDismiss(notification.id)
					}}
					aria-label="閉じる"
				>
					<Cross2Icon width={16} height={16} />
				</button>
			</div>
		</div>
	)
}
